<div class="row mt-4">
    <div class="col-12">
        <div class="form-inline">
            <span class="badge badge-warning">
                <span class="material-icons">
                    gavel
                </span>
            </span>
            <h4 class="mt-2">Auditar puntos de control</h4>
        </div>
    </div>
</div>
<div class="row mt-2">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Puestos de trabajo</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <ul class="list-group">
                        <li class="list-group-item cursor-pointer {{selectedJob.id === job.id ? 'bg-info text-white' : ''}}"
                            *ngFor="let job of jobs" (click)="selectJob(job)">
                            {{job.name}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Supervisores</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <ul class="list-group">
                        <li class="list-group-item cursor-pointer {{selectedEmployee.id === supervisor.id ? 'bg-info text-white' : ''}}"
                            *ngFor="let supervisor of supervisors" (click)="selectSupervisor(supervisor)">
                            {{supervisor.fullName}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12" *ngIf="selectedJob && selectedJob.id && !isSupervisor">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Empleados</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <ul class="list-group">
                        <li class="list-group-item cursor-pointer {{selectedEmployee.id === employee.id ? 'bg-info text-white' : ''}}"
                            *ngFor="let employee of employees" (click)="selectEmployee(employee)">
                            {{employee.fullName}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12" *ngIf="selectedEmployee && selectedEmployee.id">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Puntos de control de: {{selectedEmployee.fullName}}</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th>
                                        <span>Prioridad</span>
                                    </th>
                                    <th>
                                        <span>Punto de control</span>
                                    </th>
                                    <th>
                                        <span>Trouble-shooting</span>
                                    </th>
                                    <th>
                                        <span>Periodo</span>
                                    </th>
                                    <th>
                                        <span>Completar</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let checkpoint of checksPointsJob">
                                    <td>
                                        {{checkpoint.priority}}
                                    </td>
                                    <td>
                                        {{checkpoint.checkpoint}}
                                    </td>
                                    <td class="btn-download-cell">
                                        <button class="btn btn-sm btn-icon btn-success"
                                            (click)="downloadFile(checkpoint.url)">
                                            <span class="material-icons">
                                                download
                                            </span>
                                        </button>
                                    </td>
                                    <td>
                                        <span *ngIf="checkpoint.auditorPeriod === 1">Diaria</span>
                                        <span *ngIf="checkpoint.auditorPeriod === 7">Semanal</span>
                                        <span *ngIf="checkpoint.auditorPeriod === 15">Quincenal</span>
                                        <span *ngIf="checkpoint.auditorPeriod === 30">Mensual</span>
                                    </td>
                                    <td>
                                        <button
                                            class="btn {{checkPointsDataAuditor[checkpoint.id] ? 'btn-success' : 'btn-info'}}"
                                            (click)="doCheckPoint(checkpoint)"
                                            [disabled]="checkPointsDataAuditor[checkpoint.id]">
                                            {{checkPointsDataAuditor[checkpoint.id] ? 'Completado' : 'Completar'}}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<ngx-spinner></ngx-spinner>